import React, { useState, useRef, useEffect } from "react"
import accordionData from "../data/accordions.json"

export default function Accordion({ id }) {
  const [areAllExpanded, setAllExpanded] = useState(false)
  const [activeIndexes, setActiveIndexes] = useState([])
  const accordion = useRef()

  useEffect(() => {
    const activeItems = activeIndexes.length
    const accordionItems = accordion.current.getElementsByTagName("li").length
    activeItems === accordionItems
      ? setAllExpanded(true)
      : setAllExpanded(false)
  }, [activeIndexes.length])

  const table = accordionData.find(obj => {
    return obj.id === id
  })

  if (!table) {
    return
  }

  function addTabIndex(index) {
    let isActive = activeIndexes.includes(index)
    if (isActive) {
      setActiveIndexes(activeIndexes.filter(item => item !== index))
    } else {
      setActiveIndexes(indexes => [...indexes, index])
    }
  }

  function isActive(index) {
    let activeState = activeIndexes.includes(index)
    return activeState
  }

  function toggleAll() {
    setActiveIndexes(indexes => [])
    setAllExpanded(!areAllExpanded)
    if (!areAllExpanded) {
      table.data.forEach((item, index) => {
        setActiveIndexes(indexes => [...indexes, index])
      })
    } else {
      setActiveIndexes(indexes => [])
    }
  }

  return (
    <div className="accordion-container">
      <div className="section-header">
        <div className="section-header__text">
          <h2 className="section-header__title">{table.title}</h2>
          {table.subtitle ? (
            <div className="section-header__subtitle">{table.subtitle}</div>
          ) : null}
        </div>
        <div className="section-header__controls">
          <button onClick={() => toggleAll()} aria-controls={`${id}-accordion`}>
            {areAllExpanded ? "Collapse All" : "Show All"}
          </button>
        </div>
      </div>

      <div id={`${id}-accordion`} className="accordion">
        <ul
          id={`${id}-accordion-controls`}
          className="accordion-controls"
          aria-label="Accordion Control Group Buttons"
          ref={accordion}
        >
          {table.data.map((item, index) => {
            return (
              <li key={`${id}-accordion-control-${index}`}>
                <button
                  aria-controls={`${id}-accordion-content-${index}`}
                  aria-expanded={isActive(index)}
                  id={`${id}-accordion-control-${index}`}
                  className="accordion__button"
                  tabIndex="0"
                  onClick={() => addTabIndex(index)}
                >
                  {item.name}
                </button>
                <div
                  aria-hidden={!isActive(index)}
                  id={`${id}-accordion-content-${index}`}
                  aria-labelledby={`${id}-accordion-control-${index}`}
                  className="accordion__panel"
                  hidden={!isActive(index) ? "hidden" : ""}
                >
                  {item.items.map((child, index) => {
                    return (
                      <div
                        className="accordion__panel__child"
                        key={`accordion-${id}-child-panel-${index}`}
                      >
                        <div className="accordion__panel__child__title">
                          {child.name}
                        </div>
                        <p>{child.content}</p>
                      </div>
                    )
                  })}
                </div>
              </li>
            )
          })}
        </ul>
      </div>
      {table.footer && <footer className="title--xs">{table.footer}</footer>}
    </div>
  )
}
